module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"skills":"Ключевые навыки","FAQ":"Вопросы-ответы","address":"Адрес","published":"Вакансия опубликована"}}')
  delete Component.options._Ctor
}
